document.addEventListener('DOMContentLoaded', function () {
  // Mobile menu elements
  const mobileMenuButton = document.querySelector('[data-mobile-menu-toggle]');
  const mobileMenu = document.querySelector('[data-mobile-menu]');
  const mobileMenuClose = document.querySelector('[data-mobile-menu-close]');
  const mobileMenuBackdrop = document.querySelector('[data-mobile-menu-backdrop]');

  // Desktop flyout elements
  const flyoutButtons = document.querySelectorAll('[data-flyout-toggle]');
  const flyoutMenus = document.querySelectorAll('[data-flyout-menu]');

  // Mobile tab elements
  const tabButtons = document.querySelectorAll('[data-tab-button]');
  const tabPanels = document.querySelectorAll('[data-tab-panel]');

  // Track currently open flyout
  let currentOpenFlyout = null;

  // Mobile menu toggle functionality
  function openMobileMenu() {
    if (mobileMenu) {
      mobileMenu.classList.remove('hidden');
      // Add entering transition classes
      const backdrop = mobileMenu.querySelector('[data-mobile-menu-backdrop]');
      const panel = mobileMenu.querySelector('.fixed.inset-0.z-40.flex');

      if (backdrop) {
        backdrop.classList.add('transition-opacity', 'ease-linear', 'duration-300');
        backdrop.classList.remove('opacity-0');
        backdrop.classList.add('opacity-100');
      }

      if (panel) {
        const menuPanel = panel.querySelector('.relative.flex.w-full.max-w-xs');
        if (menuPanel) {
          menuPanel.classList.add('transition', 'ease-in-out', 'duration-300', 'transform');
          menuPanel.classList.remove('-translate-x-full');
          menuPanel.classList.add('translate-x-0');
        }
      }

      document.body.style.overflow = 'hidden';
    }
  }

  function closeMobileMenu() {
    if (mobileMenu) {
      // Add leaving transition classes
      const backdrop = mobileMenu.querySelector('[data-mobile-menu-backdrop]');
      const panel = mobileMenu.querySelector('.fixed.inset-0.z-40.flex');

      if (backdrop) {
        backdrop.classList.add('transition-opacity', 'ease-linear', 'duration-300');
        backdrop.classList.remove('opacity-100');
        backdrop.classList.add('opacity-0');
      }

      if (panel) {
        const menuPanel = panel.querySelector('.relative.flex.w-full.max-w-xs');
        if (menuPanel) {
          menuPanel.classList.add('transition', 'ease-in-out', 'duration-300', 'transform');
          menuPanel.classList.remove('translate-x-0');
          menuPanel.classList.add('-translate-x-full');
        }
      }

      // Hide after transition completes
      setTimeout(() => {
        mobileMenu.classList.add('hidden');
        document.body.style.overflow = '';
      }, 300);
    }
  }

  // Hover support: open on hover with a close delay so the menu survives the
  // pointer crossing the gap between the trigger and the panel
  const hoverMedia = window.matchMedia('(hover: hover) and (pointer: fine)');
  const FLYOUT_CLOSE_DELAY = 150;

  // Desktop flyout menu functionality
  function openFlyout(button, menu) {
    // Close any currently open flyout
    if (currentOpenFlyout && currentOpenFlyout !== menu) {
      closeFlyout(currentOpenFlyout.button, currentOpenFlyout.menu);
    }

    // Cancel a pending hide from a close that started before this open
    if (menu.hideTimer) {
      clearTimeout(menu.hideTimer);
      menu.hideTimer = null;
    }

    // Add transition classes and show
    menu.classList.add('transition', 'ease-out', 'duration-200');
    menu.classList.remove('hidden', 'opacity-0');
    menu.classList.add('opacity-100');

    // Update button state
    button.classList.remove('text-gray-700');
    button.classList.add('text-blue-600');
    button.setAttribute('aria-expanded', 'true');

    // Update bottom border
    const bottomBorder = button.querySelector('span[aria-hidden="true"]');
    if (bottomBorder) {
      bottomBorder.classList.add('bg-blue-600');
    }

    currentOpenFlyout = { button, menu };
  }

  function closeFlyout(button, menu) {
    // Add leaving transition
    menu.classList.add('transition', 'ease-in', 'duration-150');
    menu.classList.remove('opacity-100');
    menu.classList.add('opacity-0');

    // Update button state
    button.classList.remove('text-blue-600');
    button.classList.add('text-gray-700');
    button.setAttribute('aria-expanded', 'false');

    // Update bottom border
    const bottomBorder = button.querySelector('span[aria-hidden="true"]');
    if (bottomBorder) {
      bottomBorder.classList.remove('bg-blue-600');
    }

    // Hide after transition
    if (menu.hideTimer) {
      clearTimeout(menu.hideTimer);
    }
    menu.hideTimer = setTimeout(() => {
      menu.classList.add('hidden');
      menu.hideTimer = null;
    }, 150);

    if (currentOpenFlyout && currentOpenFlyout.menu === menu) {
      currentOpenFlyout = null;
    }
  }

  // Event listeners for mobile menu
  if (mobileMenuButton) {
    mobileMenuButton.addEventListener('click', openMobileMenu);
  }

  if (mobileMenuClose) {
    mobileMenuClose.addEventListener('click', closeMobileMenu);
  }

  if (mobileMenuBackdrop) {
    mobileMenuBackdrop.addEventListener('click', closeMobileMenu);
  }

  // Desktop flyout click functionality
  flyoutButtons.forEach((button, index) => {
    const flyoutMenu = flyoutMenus[index];

    if (flyoutMenu) {
      button.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();

        const isOpen = button.getAttribute('aria-expanded') === 'true';

        // On hover devices the menu is already open under the pointer; a mouse
        // click (detail > 0) shouldn't snap it shut. Keyboard activation
        // (detail === 0) still toggles.
        if (isOpen && hoverMedia.matches && e.detail > 0) {
          return;
        }

        if (isOpen) {
          closeFlyout(button, flyoutMenu);
        } else {
          openFlyout(button, flyoutMenu);
        }
      });

      if (hoverMedia.matches) {
        let closeTimer = null;

        const cancelClose = () => {
          if (closeTimer) {
            clearTimeout(closeTimer);
            closeTimer = null;
          }
        };

        const scheduleClose = () => {
          cancelClose();
          closeTimer = setTimeout(() => {
            closeTimer = null;
            if (button.getAttribute('aria-expanded') === 'true') {
              closeFlyout(button, flyoutMenu);
            }
          }, FLYOUT_CLOSE_DELAY);
        };

        [button, flyoutMenu].forEach((el) => {
          el.addEventListener('mouseenter', () => {
            cancelClose();
            if (button.getAttribute('aria-expanded') !== 'true') {
              openFlyout(button, flyoutMenu);
            }
          });
          el.addEventListener('mouseleave', scheduleClose);
        });
      }
    }
  });

  // Close flyouts when clicking outside
  document.addEventListener('click', function (e) {
    if (
      currentOpenFlyout &&
      !currentOpenFlyout.button.contains(e.target) &&
      !currentOpenFlyout.menu.contains(e.target)
    ) {
      closeFlyout(currentOpenFlyout.button, currentOpenFlyout.menu);
    }
  });

  // Mobile tab functionality
  tabButtons.forEach((button) => {
    button.addEventListener('click', function () {
      const targetPanelId = button.getAttribute('aria-controls');
      const targetPanel = document.getElementById(targetPanelId);

      if (targetPanel) {
        // Remove active states from all tabs and panels
        tabButtons.forEach((btn) => {
          btn.classList.remove('border-primary', 'text-primary');
          btn.classList.add('border-transparent', 'text-gray-900');
          btn.setAttribute('aria-selected', 'false');
        });

        tabPanels.forEach((panel) => {
          panel.classList.add('hidden');
        });

        // Add active state to clicked tab
        button.classList.remove('border-transparent', 'text-gray-900');
        button.classList.add('border-primary', 'text-primary');
        button.setAttribute('aria-selected', 'true');

        // Show target panel
        targetPanel.classList.remove('hidden');
      }
    });
  });

  // Initialize: Mobile menu should already be hidden in HTML
  // No need to hide flyout menus as they now have hidden and opacity-0 classes by default

  // Initialize: Show first tab panel and hide others
  if (tabPanels.length > 0) {
    tabPanels.forEach((panel, index) => {
      if (index === 0) {
        panel.classList.remove('hidden');
      } else {
        panel.classList.add('hidden');
      }
    });
  }

  // Close flyouts and mobile menu on escape key
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') {
      if (currentOpenFlyout) {
        closeFlyout(currentOpenFlyout.button, currentOpenFlyout.menu);
      }
      if (mobileMenu && !mobileMenu.classList.contains('hidden')) {
        closeMobileMenu();
      }
    }
  });
});
